import { Select, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { TIMESHEET_TYPE_OPTIONS, TASK_STATUS_OPTIONS } from './constants';

export const FilterSelect = ({
    placeholder,
    options = [],
    value,
    onChange,
    width = 180,
    mode = "multiple",
}) => (
    <Select
        mode={mode}
        allowClear
        showSearch
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        options={options}
        style={{ width }}
        maxTagCount="responsive"
    />
);

export const ApprovalFilterBar = ({
    userOptions = [],
    projectOptions = [],
    userValue = [],
    projectValue = [],
    onUserChange,
    onProjectChange,
    onRefresh,
    loading = false,
    extraActions,
}) => (
    <div className="flex justify-between mb-4 flex-wrap gap-2">
        <div className="flex space-x-2 flex-wrap gap-y-2">
            <FilterSelect
                placeholder="Filter by User"
                options={userOptions}
                value={userValue}
                onChange={onUserChange}
                width={200}
            />
            <FilterSelect
                placeholder="Filter by Project"
                options={projectOptions}
                value={projectValue}
                onChange={onProjectChange}
                width={200}
            />
        </div>
        <Space wrap>
            <Button onClick={onRefresh} loading={loading} icon={<ReloadOutlined />}>
                Refresh
            </Button>
            {extraActions}
        </Space>
    </div>
);

export const DashboardFilterBar = ({
    options = { user: [], company: [], project: [], manager: [] },
    filters = { users: [], companies: [], projects: [], managers: [] },
    onFilterChange,
    onRefresh,
    loading = false,
    showManagerFilter = false,
}) => (
    <div className="flex justify-between mb-4 flex-wrap gap-2">
        <div className="flex space-x-2 flex-wrap gap-y-2">
            <FilterSelect
                placeholder="Filter by Company"
                options={options.company}
                value={filters.companies}
                onChange={(val) => onFilterChange({ ...filters, companies: val })}
            />
            <FilterSelect
                placeholder="Filter by User"
                options={options.user}
                value={filters.users}
                onChange={(val) => onFilterChange({ ...filters, users: val })}
            />
            <FilterSelect
                placeholder="Filter by Project"
                options={options.project}
                value={filters.projects}
                onChange={(val) => onFilterChange({ ...filters, projects: val })}
            />
            {showManagerFilter && (
                <FilterSelect
                    placeholder="Filter by Manager"
                    options={options.manager}
                    value={filters.managers}
                    onChange={(val) => onFilterChange({ ...filters, managers: val })}
                />
            )}
        </div>
        <Button onClick={onRefresh} loading={loading} icon={<ReloadOutlined />}>
            Refresh
        </Button>
    </div>
);

export const DataEntryStatusFilter = ({ value, onChange }) => (
    <FilterSelect
        mode="default"
        placeholder="Filter by Status"
        options={TASK_STATUS_OPTIONS}
        value={value}
        onChange={onChange}
        width={160}
    />
);

export const ReportPreviewFilterBar = ({
    reportType,
    timesheetType,
    onTimesheetTypeChange,
    userOptions = [],
    projectOptions = [],
    userFilterValue,
    projectFilterValue,
    onUserFilterChange,
    onProjectFilterChange,
}) => (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>

        {reportType === 'leave' && (
            <>
                <FilterSelect
                    mode="default"
                    placeholder="Filter by User"
                    options={userOptions}
                    value={userFilterValue}
                    onChange={onUserFilterChange}
                    width={200}
                />
                <FilterSelect
                    mode="default"
                    placeholder="Filter by Project"
                    options={projectOptions.map(p => ({ label: p, value: p }))}
                    value={projectFilterValue}
                    onChange={onProjectFilterChange}
                    width={200}
                />
            </>
        )}

        {['user', 'project'].includes(reportType) && (
            <FilterSelect
                mode="default"
                placeholder="Filter by Type"
                options={TIMESHEET_TYPE_OPTIONS}
                value={timesheetType}
                onChange={(val) => onTimesheetTypeChange(val || null)}
                width={200}
            />
        )}
    </div>
);